import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useDataStoreList } from './DataStoreItemsListHooks';

export function DataStoreItemsList() {
  const { t } = useTranslation();
  const { dataStoreItems, currentDataset, selectDatasetAndRunner, setLoading } = useDataStoreList();

  const handleDataStoreSelection = useCallback(
    (event) => {
      setLoading(true);
      const selectedDatasetId = event.target.value;
      const matchedDataStore = dataStoreItems.find((dataStoreItem) => dataStoreItem.id === selectedDatasetId);
      selectDatasetAndRunner(matchedDataStore);
    },
    [selectDatasetAndRunner, setLoading, dataStoreItems]
  );

  const datastores = useMemo(() => {
    return dataStoreItems.map((dataStoreItem) => (
      <MenuItem value={dataStoreItem.id} key={dataStoreItem.id}>
        {dataStoreItem.name}
      </MenuItem>
    ));
  }, [dataStoreItems]);

  return (
    <FormControl sx={{ width: '100%', minWidth: '250px', maxWidth: '500px' }}>
      <InputLabel id="datastore-select-label">
        {t('commoncomponents.datastore.select.label', 'Select a datastore')}
      </InputLabel>
      <Select
        labelId="datastore-select-label"
        id="datastore-select"
        value={currentDataset?.id || ''}
        label={t('commoncomponents.datastore.select.label', 'Select a datastore')}
        onChange={handleDataStoreSelection}
      >
        {datastores}
      </Select>
    </FormControl>
  );
}
